import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import axios from 'axios';
import './AdminLogin.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3006/api';

function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        
        if (!username.trim() || !password.trim()) {
            setError('Please enter username and password');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${API_BASE_URL}/admin/login`, {
                username: username.trim(),
                password: password.trim()
            });

            if (response.data.success) {
                localStorage.setItem('adminToken', response.data.token);
                localStorage.setItem('adminUser', JSON.stringify(response.data.user));
                navigate('/admin/dashboard');
            } else {
                setError(response.data.message || 'Login failed');
            }
        } catch (err) {
            console.error('Login error:', err);
            if (err.response?.status === 401) {
                setError('Invalid username or password');
            } else if (err.response?.status === 403) {
                setError('Account is disabled or locked');
            } else {
                setError('Unable to connect to server. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-background">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
            </div>
            
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <div className="admin-logo">
                        <i className="pi pi-shield"></i>
                    </div>
                    <h1>Admin Portal</h1>
                    <p>NEDP School Management System</p>
                </div>

                <form onSubmit={handleLogin} className="admin-login-form">
                    {error && (
                        <Message severity="error" text={error} className="admin-error-message" />
                    )}

                    <div className="admin-field">
                        <label htmlFor="username">
                            <i className="pi pi-user"></i>
                            Username
                        </label>
                        <InputText
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your username"
                            className="admin-input"
                            disabled={loading}
                            autoComplete="username"
                        />
                    </div>

                    <div className="admin-field">
                        <label htmlFor="password">
                            <i className="pi pi-lock"></i>
                            Password
                        </label>
                        <Password
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            className="admin-input"
                            feedback={false}
                            toggleMask
                            disabled={loading}
                            autoComplete="current-password"
                        />
                    </div>

                    <Button
                        type="submit"
                        label={loading ? 'Signing in...' : 'Sign In'}
                        icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-sign-in'}
                        className="admin-login-button"
                        disabled={loading}
                    />
                </form>

                <div className="admin-login-footer">
                    <small>Authorized personnel only</small>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
